import React, { FC } from "react";
import { Link, LinkProps } from "react-router-dom";
import mergeClasses from "classnames";
import useStyles from "./styles";

const DPLink: FC<LinkProps> = ({ className, children, ...rest }) => {
  const classes = useStyles();
  const linkClassName = mergeClasses(className, classes.link);
  return (
    <Link className={linkClassName} {...rest}>
      {children}
    </Link>
  );
};

export default DPLink;
